





















































































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class Result extends Vue {

  @Prop({type: Object, default: null})
  private restProps!: any;

  @Prop({type: String, default: null})
  private title!: string;

  @Prop({type: String, default: 'error'})
  private type!: 'error'|'success';
}
